import { Fragment, useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ProcessContext from '../../contexts/process/ProcessContext';
import StatusBarButton from '../layout/StatusBarButton';
import NumberPad from './NumberPad';

const EntitySelector = ({ forwardTo, allPanels, center , entity}) => {
  const { continueProcess, activeProcessId, notifyError} = useContext(ProcessContext);
  const [activeCard, setActiveCard] = useState(null);
  const [display, setDisplay] = useState({
    prefix: '',
    value: '',
  });
  const location = useLocation();
  const centerClass = center === true ? 'selector-center' : ''
  const entityValidatorRegexPattern = /^(t(?:[1-9]|[1-9][0-9]|100)|p(?:[1-9]|[1-7][0-9]|88))$/;

  const navigate = useNavigate();

  useEffect(() => {
    if (entity && entityValidatorRegexPattern.test(entity)) {
      setDisplay({
        prefix: entity[0],
        value: entity.slice(1),
      });
    }
  }, [entity]);

  useEffect(() => {
    if (entity && display && display.prefix && display.value) {
      const automatedProcess = async () => {
        await finishSelection();
      };
      automatedProcess();
    }
  }, [display])

  const handleClick = async (prefix) => {
    if (prefix == 'a_p') {
      setActiveCard(prefix);
      setDisplay((prev) => ({ ...prev, prefix }));
    try{
      await continueProcess(activeProcessId, prefix);
      navigate(forwardTo + '/' + 'submit-report');
    } catch (error) {
      console.error(error);
    }
    } else {
      setActiveCard(prefix);
      setDisplay((prev) => ({ ...prev, prefix }));
    }
  };

  const finishSelection = async () => {
    if (display.prefix == "p") {
      if (parseInt(display.value) > parseInt(import.meta.env.VITE_MAX_PANEL_NUMBER) || parseInt(display.value) < 1) {
        notifyError(`You tried to enter an invalid panel. Please select a panel between 1 and ${import.meta.env.VITE_MAX_PANEL_NUMBER}`)
        return;
      }
    }
    if (display.prefix == "t") {
      if (parseInt(display.value) > parseInt(import.meta.env.VITE_MAX_TRAY_NUMBER) || parseInt(display.value) < 1) {
        notifyError(`You tried to enter an invalid tray. Please select a tray between 1 and ${import.meta.env.VITE_MAX_TRAY_NUMBER}`)
        return;
      }
    }
    const entityName = `${display.prefix}${display.value}`;
    if (display.prefix === "t") {
      if (parseInt(display.value, 10) > parseInt(import.meta.env.VITE_MAX_TRAY_NUMBER, 10)) {
        notifyError(`You tried to enter an invalid tray. Please select a tray between 1 and ${import.meta.env.VITE_MAX_TRAY_NUMBER}`);
        return;
      }
    }
    if (display.prefix === "p") {
      if (parseInt(display.value, 10) > parseInt(import.meta.env.VITE_MAX_PANEL_NUMBER, 10)) {
        notifyError(`You tried to enter an invalid panel. Please select a panel between 1 and ${import.meta.env.VITE_MAX_PANEL_NUMBER}`);
        return;
      }
    }
    try {
      await continueProcess(activeProcessId, entityName);
      const target = determineTarget(display.prefix);
      if (target === "destination-selection") {
        const selectionType = display.prefix;
        navigate(forwardTo + '/' + target, {state: {selectionType}});
      }
      else{
        navigate(forwardTo + '/' + target);
      }
    } catch (error) {
      notifyError(<>We have encountered a problem while continuing the Process. Please contact the support team {HELP_DESK_LINK}.</>)
      console.error(error);
    }
  };

  const setValue = (value) => {
    setDisplay((prev) => ({ ...prev, value }));
  };

  const determineTarget = (prefix) => {
    if (location.pathname === "/repositioning") {
      return "destination-selection";
    };

    switch (prefix) {
      case 't':
        return 'tray';
      case 'p':
        return 'panel';
      case 'a_p':
        return 'submit-report';
      default:
        return null;
    }
  };

  return (
    <Fragment>
      <div className={`entity-selector ${centerClass}`} style={{ overflowY: !!activeCard ? 'unset' : 'hidden' }}>
        <div className='entity-cards-container' data-shrink={!!display.prefix}>
          <div className='entity-card' data-selected={activeCard === 't'} onClick={() => handleClick('t')}>
            <i className='fas fa-th'></i>
            <span>Tray</span>
          </div>
          <div className='entity-card' data-selected={activeCard === 'p'} onClick={() => handleClick('p')}>
            <i className='fas fa-grip-lines-vertical'></i>
            <span>Panel</span>
          </div>
          {allPanels && (
            <div className='entity-card' data-selected={activeCard === 'a_p'} onClick={() => handleClick('a_p')}>
              <i className='fas fa-layer-group'></i>
              <span>All Panels</span>
            </div>
          )}
        </div>
        <div className='numpad-container' data-visible={!!display.prefix}>
          <NumberPad disabled={display.prefix === ''} prefix={''} value={display.value} setValue={setValue} />
        </div>
      </div>
      {display.prefix && display.value && (
        <StatusBarButton
          label='Continue'
          icon='fas fa-chevron-right'
          reversed={true}
          clickHandler={finishSelection}
          statusSlot={5}
        />
      )}
    </Fragment>
  );
};

export default EntitySelector;
